import clsx from 'clsx';
import { Button } from 'flowbite-react';
import { LifeBuoyIcon } from 'lucide-react';
import { useContext } from 'react';

import { DocumentEditorContext } from '../contexts/documentEditor.context';

export interface DocumentIntroSectionProps {
    className?: string;
}

export const DocumentIntroSection: React.FC<DocumentIntroSectionProps> = ({
    className
}) => {
    const { requestHelp } = useContext(DocumentEditorContext);

    return (
        <div className={clsx(
            'flex flex-col gap-6',
            className
        )}>
            <div className='flex flex-col gap-4 px-5'>
                <h1 className='text-2xl md:text-3xl font-medium text-[#0b111e]'>Jak psát tento dokument?</h1>
                <p className='text-lg font-semibold text-gray-400 tracking-widest uppercase'>Připravujeme</p>
                <div>
                    <Button
                        color='help'
                        className='flex-shrink-0'
                        onClick={() => requestHelp()}
                    ><LifeBuoyIcon size={18} /> <span className='ml-2'>Potřebuji pomoc / Chci se poradit</span></Button>
                </div>
            </div>
        </div>
    );
};
